export default "__VITE_PUBLIC_ASSET__e06a55e2__"